import { atom } from 'jotai'
import { PaymentsResponse } from 'types/payments'
import { WalletType } from 'types/types'
import { SendStep } from 'types/walletActions'

export const sendStepAtom = atom<SendStep>(SendStep.CONTACT)
sendStepAtom.debugLabel = 'send-step'
export const sendWalletAtom = atom<WalletType>()
sendWalletAtom.debugLabel = 'send-wallet'

export const estimateIdAtom = atom('')
estimateIdAtom.debugLabel = 'estimate-id'

export const paymentAtom = atom<PaymentsResponse>()
paymentAtom.debugLabel = 'payment'
